import React, { useEffect, useState } from "react";
import Select from "../../../components/Form/Select";
import { MVM_STATUS } from "../../../utils/constants";

type Props = any;

const SelectStatus: React.FC<Props> = ({ name, control, multiple, style, label, context}) => {
  
  const [mvmstatusList, setMvmstatusList] = useState<any>([])

  useEffect(() => {
    setMvmstatusList(MVM_STATUS);
  }, []);

  return (
    <Select 
      label={label} 
      name={name}
      control={control} 
      options={mvmstatusList}
      multiple={multiple}
      style={style ? style : {width: '100%'}}/>
  )
}

export default SelectStatus;
